var jcsfApp;
(function (jcsfApp) {
	var app;
	(function (app) {
		var auth;
		(function (auth) {
			var redirController = (function () {
				function redirController(authService, $scope) {				
					let cookieValue = getCookie('Shim');
					if (cookieValue) {
						authService.loginfs(cookieValue).then(
							function (response) {
								document.cookie = 'Shim=complete';
								if (response.authenticated === true) {
									$scope.$state.go('home');
								} else {
									console.log("Credentials not authenticated.");    
									$scope.$state.go('invalidCredentials');
								}
							},
							function () {
								console.log("Error encountered during login"); 
								$scope.$state.go('invalidCredentials');
							}
						);
					} else {
						console.info('Redir found no cookie');
						$scope.$state.go('notAuthorized');
					}
				}

				function getCookie(cookieName) {
					let cookies = document.cookie.split(';');
					for (let c = 0; c < cookies.length; c++) {
						let cookiePair = cookies[c].split('=');
						if (cookieName === cookiePair[0].trim()) {
							console.info('Found cookie with value ' + cookiePair[1]);
							return cookiePair[1];
						}
					}
					return '';
				}
				redirController.$inject = ['authService', '$scope'];
				return redirController;
			})();

			angular.module('jcsfApp').controller('redirController', redirController);
		})((auth = app.auth || (app.auth = {})));
	})((app = jcsfApp.app || (jcsfApp.app = {})));

})(jcsfApp || (jcsfApp = {}));
